import { REPORT_TYPES, REPORT_CATEGORIES, VERTICALS, GRAPH_TYPES } from "../../../../constants/app-constant"

export const getCorrectChartTitle = (
    type,
    reportType,
    selectedInlineGraphType,
    selectedInlineDynamicFilter,
    selectedInlineEntity,
    selectedInlineSentiment,
    selectedInlineSpokesperson,
    selectedInlinePublicationGenre,
    datasetIndex,
) => {
    const reportId = reportType.id;
    let chartTitle = reportType.label;
    if (/Publication/.test(reportId)) {
        if (!/NewEntity/.test(reportId)) {
            const topTen = datasetIndex === 0 ? "Top 10" : "";
            chartTitle = (type === VERTICALS.V_ONLINE) ?
                chartTitle.replace('Publication', `${topTen} Websites`) :
                chartTitle.replace('Publication', `${topTen} Publications`);
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.SOV) {
        if (
            ((/Ranking/.test(reportId) && selectedInlineGraphType === GRAPH_TYPES.PIE) ||
                /Trend/.test(reportId) ||
                /Tonality/.test(reportId)) &&
            !/Entity/.test(reportId)
        ) {
            chartTitle += ` (${selectedInlineEntity.value})`;
        }
        if (
            (/Tonality/.test(reportId) && selectedInlineGraphType === GRAPH_TYPES.PIE)
        ) {
            chartTitle += ` (${selectedInlineSentiment.value})`;
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.THEMATIC_ANALYSIS) {
        if (
            (/SOV/.test(reportId) &&
                (
                    !/Entity/.test(reportId) ||
                    selectedInlineGraphType === GRAPH_TYPES.PIE
                )) ||
            /Trend/.test(reportId) ||
            /Tonality/.test(reportId)
        ) {
            if (/Trend/.test(reportId) && !/Entity/.test(reportId)) {
                chartTitle += ` (${selectedInlineEntity.value})`;
            }
            chartTitle += ` (${selectedInlineDynamicFilter.value})`;
            if (/Tonality/.test(reportId) && !/Entity/.test(reportId)) {
                chartTitle += ` (${selectedInlineSentiment.value})`;
            }
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.GEOLOCATION) {
        if (/Trend/.test(reportId)) {
            chartTitle += ` (${selectedInlineDynamicFilter.value})`;
        }
        if (
            (/SOV/.test(reportId) && !/Entity/.test(reportId)) ||
            (/Trend/.test(reportId) && (!/Entity/.test(reportId) || type === VERTICALS.V_ONLINE))
        ) {
            chartTitle += ` (${selectedInlineEntity.value})`;
        }
        if (/Tonality/.test(reportId)) {
            chartTitle += ` (${selectedInlineDynamicFilter.value})`;
            if ((!/Entity/.test(reportId) || type === VERTICALS.V_ONLINE)) {
                chartTitle += ` (${selectedInlineSentiment.value})`;
            }
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.JOURNALIST) {
        if (/SOV/.test(reportId) && !/Entity/.test(reportId)) {
            chartTitle += ` (${selectedInlineDynamicFilter.value})`;
        }
        if (/Trend/.test(reportId) || /Tonality/.test(reportId)) {
            chartTitle += ` (${selectedInlineDynamicFilter.value})`;
            if (!/Entity/.test(reportId) && /Trend/.test(reportId)) {
                chartTitle += ` (${selectedInlineEntity.value})`;
            }
            if (!/Entity/.test(reportId) && /Tonality/.test(reportId)) {
                chartTitle += ` (${selectedInlineSentiment.value})`;
            }
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.SPOKESPERSON) {
        if ((/SOV/.test(reportId) && !/Entity/.test(reportId)) || /Trend/.test(reportId)) {
            chartTitle += ` (${selectedInlineSpokesperson.value})`;
            if (/Trend/.test(reportId) && !/Entity/.test(reportId)) {
                chartTitle += ` (${selectedInlineEntity.value})`;
            }
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.SENTIMENT) {
        if (!/NewEntity/.test(reportId)) {
            chartTitle += ` (${selectedInlineSentiment.value})`;
            if (
                (/Trend/.test(reportId) && !/Entity/.test(reportId)) ||
                (/SOV/.test(reportId) && !/Entity/.test(reportId) && selectedInlineGraphType === GRAPH_TYPES.PIE)
            ) {
                chartTitle += ` (${selectedInlineEntity.value})`;
            }
        }

    }
    if (reportType.reportCategory === REPORT_CATEGORIES.KEYWORD_CLOUD) {
        if (
            (/SOV/.test(reportId) && !/Entity/.test(reportId)) ||
            /Tonality/.test(reportId) ||
            /Trend/.test(reportId)
        ) {
            chartTitle += ` (${selectedInlineDynamicFilter.value})`;
            if (/Tonality/.test(reportId) && !/Entity/.test(reportId)) {
                chartTitle += ` (${selectedInlineSentiment.value})`;
            }
            if (/Trend/.test(reportId) && !/Entity/.test(reportId)) {
                chartTitle += ` (${selectedInlineEntity.value})`;
            }
        }
    }
    if (reportType.reportCategory === REPORT_CATEGORIES.PUBLICATION) {
        if (!/NewEntity/.test(reportId)) {
            if (/SOV/.test(reportId) || /Trend/.test(reportId) || /Tonality/.test(reportId)) {
                if (type === VERTICALS.V_PRINT)
                    chartTitle += ` (${selectedInlinePublicationGenre.value})`;
                if (/Trend/.test(reportId)) {
                    chartTitle += ` (${selectedInlineDynamicFilter.value})`;
                }
                if (/Tonality/.test(reportId)) {
                    chartTitle += ` (${selectedInlineSentiment.value})`;
                }
                if (!/Entity/.test(reportId)) {
                    chartTitle += ` (${selectedInlineEntity.value})`;
                }
            }
        }
    }
    return chartTitle;
}